<template>
  <div class="bb-notifications-window-mailing">
    <i
      class="icon-cross bb-notifications-window-mailing__icon"
      @click.stop="onDelete"
    />
    <div
      class="bb-notifications-window-mailing__icon-mail"
      v-html="EmailIcon()"
    />
    <div class="bb-notifications-window-mailing-right">
      <div class="bb-notifications-window-mailing__title">
        Mailing
      </div>
      <div class="bb-notifications-window-mailing__subject">
        {{subject}}
      </div>
      <div class="bb-notifications-window-mailing__description">
        {{description}}
      </div>
    </div>
  </div>
</template>

<script>
import { EmailIcon } from '@/constants/icon'

export default {
  name: 'NotificationsWindowMailing',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    EmailIcon,
    subject: '',
    description: ''
  }),
  methods: {
    onDelete () {
      this.$emit('onDelete', this.index)
    },
    parsComment () {
      const { comment } = this.item
      const value = comment.split('Æ')
      if (!value.length) return
      const [subject, description] = value
      this.subject = subject
      this.description = description
    }
  },
  beforeMount () {
    this.parsComment()
  }
}
</script>

  <style lang="scss" scoped>
  @import "../../../sass/variables";

    .bb-notifications-window-mailing {
      display: grid;
      grid-template-columns: 36px 1fr;
      grid-gap: 0 16px;
      width: 292px;
      min-height: 79px;
      padding: 16px 18px 16px 18px;
      border-radius: 4px;
      background: $color-white;
      box-shadow: 0 0 20px rgba($color-black, 0.07);
      position: relative;

      &__icon {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 24px;
        font-size: 12px;
        color: $color-silver-deep;
        cursor: pointer;
        transition: 0.3s;

        &:before {
          margin: 0;
        }

        &:hover {
          color: $color-dusty-gray
        }
      }

      &__title {
        font-size: 13px;
        font-weight: 500;
        line-height: 16px;
      }

      &__subject {
        font-size: 11px;
        font-weight: 500;
        line-height: 13px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      &__description {
        font-size: 11px;
        font-weight: 300;
        line-height: 13px;
      }
    }

    .bb-notifications-window-mailing-right {
      display: grid;
      grid-gap: 7px 0;
    }
  </style>

  <style lang="scss">
  @import "../../../sass/variables";

    .bb-notifications-window-mailing {

      &__icon-mail {

        svg {
          width: 32px;
          height: 32px;

          path {
            fill: $color-denim;
          }
        }
      }
    }
  </style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsWindow/NotificationsWindowMailing.vue